import type { ElementType, ReactNode, ComponentPropsWithoutRef } from 'react';

import { cls } from '@/utils/cls';

type Props<T extends ElementType = 'div'> = {
  as?: T;
  children?: ReactNode;
  className?: string;
} & Omit<ComponentPropsWithoutRef<T>, 'as' | 'children' | 'className'>;

export function Container<T extends ElementType = 'div'>({ as, className, children, ...rest }: Props<T>) {
  const Component = as ?? 'div';
  const containerClass = cls('w-full max-w-[1732px] mx-auto py-4 px-6 3xl:px-0', className);

  return (
    <Component {...rest} className={containerClass}>
      {children}
    </Component>
  );
}
